import { createSlice } from "@reduxjs/toolkit";
import { BuscarTaxaImpostoModel } from "../../../models/taxaImposto/buscaTaxaImpostoModel";
import { TaxaImpostoModel } from "../../../models/taxaImposto/taxaImpostoModel";
import { buscarTaxaImposto } from "../../../services/taxaImpostoService";
import { resetAll } from "../../actions/actions";

export interface TaxaImpostoState {
  //buscar taxa imposto
  loading: boolean;
  busca: BuscarTaxaImpostoModel;
  list: TaxaImpostoModel[];
  entity: TaxaImpostoModel;
  //internal
  page: string;
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: TaxaImpostoState = {
  //buscar taxa imposto
  loading: false,
  busca: {
    id: null,
    pesquisar: null,
  } as BuscarTaxaImpostoModel,
  list: [],
  entity: {} as TaxaImpostoModel,
  //internal
  page: "geral",
  modalCadastrar: false,
  modalDeletar: false,
};

export const taxaImpostoSlice = createSlice({
  name: "taxaImposto",
  initialState,
  reducers: {
    //buscar taxa imposto
    setBuscaTaxaImposto: (state, action) => {
      state.busca = action.payload;
    },
    setEntityTaxaImposto: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setPageTaxaImposto: (state, action) => {
      state.page = action.payload;
    },
    setModalDeletarTaxaImposto: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar taxa imposto
    builder.addCase(buscarTaxaImposto.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTaxaImposto.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTaxaImposto.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar taxa imposto
  setBuscaTaxaImposto,
  setEntityTaxaImposto,
  //internal
  setPageTaxaImposto,
  setModalDeletarTaxaImposto,
} = taxaImpostoSlice.actions;

export default taxaImpostoSlice.reducer;
